var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"builder-behavior-input"},[_c('ToggleInput',{attrs:{"value":_vm.value},on:{"input":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }